export const about = {
  'seo.title': 'Om oss — Sofia og Elena | Eksperter i Ernæring og Kosmetologi',
  'seo.description': 'Møt Sofia og Elena — to ekspert ernæringsfysiologer som arbeider på skjæringspunktet mellom ernæring og kosmetologi.',
  'seo.keywords': 'Sofia ernæringsfysiolog, Elena ernæringsfysiolog, barneernæring, hormonell balanse, mage-tarm, metabolisme',

  'hero.title': 'To eksperter.\nEtt resultat.',
  'hero.description': 'Vi er ikke bare to venner. Vi er et konsultasjonsteam som arbeider på skjæringspunktet mellom ernæring og kosmetologi, slik at kroppen din høres vakker ut innvendig og utvendig.',

  'whyTwo.title': 'Hvorfor to eksperter = ditt resultat ×10',
  'whyTwo.doubleControl.title': 'Dobbel kontroll',
  'whyTwo.doubleControl.description': 'Mens en ekspert gjenoppretter din hormonelle balanse og mage-tarm funksjon, bygger den andre opp metabolismen din, arbeider med mangler og sørger for at huden din stråler.',
  'whyTwo.deepExpertise.title': 'Dyp ekspertise',
  'whyTwo.deepExpertise.description': 'Du får dyp ekspertise fra to sider samtidig. Vi behandler ikke symptomer — vi gjenoppbygger helsen din "murstein for murstein".',
  'whyTwo.quote': 'Dette er ikke bare en konsultasjon. Dette er et konsultasjonsteam der hver detalj av helsen din undersøkes under mikroskopet til to fagpersoner.',

  'experts.title': 'Våre superkrefter',
  'experts.sofia.name': 'Sofia',
  'experts.sofia.title': 'Ernæringsfysiolog med kosmetologisk bakgrunn',
  'experts.sofia.feature1': 'Ekspert på barneernæring — vet hvordan man former sunn spiseatferd fra vuggen',
  'experts.sofia.feature2': 'Arbeider med veganere og idrettsutøvere — bygger ernæring for maksimal ytelse',
  'experts.sofia.feature3': 'Vet hvordan man får ansiktet til å se 5 år yngre ut mens man går ned i vekt',
  'experts.sofia.imageAlt': 'Sofia — ernæringsfysiolog med kosmetologisk bakgrunn',
  'experts.elena.name': 'Elena',
  'experts.elena.title': 'Ernæringsfysiolog ekspert på mage-tarm og hormoner',
  'experts.elena.feature1': '"Alkymist" av kroppen din — finner de sanne årsakene til betennelser og feil',
  'experts.elena.feature2': 'Ekspert på gjenoppretting av hormonell balanse og mage-tarm funksjon',
  'experts.elena.feature3': 'Arbeider med metabolisme og mangler på dypt nivå',
  'experts.elena.imageAlt': 'Elena — ernæringsfysiolog ekspert på mage-tarm og hormoner',

  'philosophy.title': 'Kaos i hodet = kaos i kroppen',
  'philosophy.belief': 'Vi tror ikke på dietter. Vi tror på kunnskap.',
  'philosophy.description': 'Vi lærer deg å forstå kroppens signaler, slik at du om 2 måneder blir din egen beste ernæringsfysiolog. Dette er ikke en midlertidig diett — det er en ny livsstil.',
  'philosophy.education.title': 'Utdanning',
  'philosophy.education.description': 'Vi gir deg kunnskap, ikke bare en måltidsplan',
  'philosophy.awareness.title': 'Bevissthet',
  'philosophy.awareness.description': 'Vi lærer deg å høre og forstå kroppens signaler',
  'philosophy.sustainability.title': 'Bærekraft',
  'philosophy.sustainability.description': 'Vi skaper vaner som vil bli hos deg for alltid',

  'cta.title': 'Klar til å starte reisen til deg selv?',
  'cta.description': 'Meld deg på en gratis diagnostikk, og vi viser deg hvordan tilnærmingen vår fungerer i praksis.',
  'cta.primary': 'Velg program',
  'cta.secondary': 'Lær mer',
  'cta.primaryAria': 'Velg et ernæringsprogram',
  'cta.secondaryAria': 'Lær mer om tjenestene våre',
};